document.addEventListener('DOMContentLoaded', function () {
    // Select all tabs and sections
    const tabs = document.querySelectorAll('header.header .tabtop');
    const sections = document.querySelectorAll('.sec-capsule, .sec-sunday, .sec-sport, .sec-core');
    const header = document.querySelector('header.header');
    const headerHeight = header ? header.offsetHeight : 0;
  
    console.log('Tabs encontrados:', tabs);
    console.log('Secciones encontradas:', sections);
  
    // Define offsets for desktop, tablet, and mobile
    const desktopOffset = 109; // Distance for desktop
    const tabletOffset = 152;  // Distance for tablet (below 1120px)
    const mobileOffset = 52;  // Distance for mobile (below 768px)
  
    // Smooth scroll on tab click
    tabs.forEach((tab) => {
      tab.addEventListener('click', (e) => {
        e.preventDefault();
        console.log('Click en tab:', tab);
  
        // Obtener la clase target
        const targetClass = tab.className
          .split(' ')
          .find((cls) => cls.startsWith('tab-'));
  
        console.log('Clase target:', targetClass);
  
        if (targetClass) {
          const targetSectionClass = targetClass.replace('tab-', 'sec-');
          console.log('Clase de la sección objetivo:', targetSectionClass);
  
          const targetSection = document.querySelector(`.${targetSectionClass}`);
          console.log('Sección objetivo encontrada:', targetSection);
  
          if (targetSection) {
            // Determine offset based on screen size
            let offset;
            if (window.innerWidth > 1120) {
              offset = desktopOffset; // Desktop
            } else if (window.innerWidth > 768) {
              offset = tabletOffset; // Tablet
            } else {
              offset = mobileOffset; // Mobile
            }
  
            // Usar getBoundingClientRect().top para calcular la posición correcta
            const sectionTop = targetSection.getBoundingClientRect().top + window.scrollY;
            const targetPosition = sectionTop - offset;
  
            console.log('Desplazándose a posición:', targetPosition);
  
            window.scrollTo({
              top: targetPosition,
              behavior: 'smooth',
            });
          } else {
            console.error(`No se encontró ninguna sección con la clase .${targetSectionClass}`);
          }
        } else {
          console.error('No se encontró ninguna clase target en:', tab.className);
        }
      });
    });
  
    // Add active class to tab on scroll
    window.addEventListener('scroll', () => {
      let currentSection = null;
  
      sections.forEach((section) => {
        const sectionTop = section.getBoundingClientRect().top + window.scrollY - headerHeight + 0;
        const sectionBottom = sectionTop + section.offsetHeight;
  
        if (window.scrollY >= sectionTop && window.scrollY < sectionBottom) {
          currentSection = section.className
            .split(' ')
            .find((cls) => cls.startsWith('sec-'));
        }
      });
  
      console.log('Sección actual visible:', currentSection);
  
      tabs.forEach((tab) => {
        const parent = tab.closest('.navigation-item'); // Encuentra el elemento padre con clase 'navigation-item'
        const tabClass = tab.className
          .split(' ')
          .find((cls) => cls.startsWith('tab-'))
          ?.replace('tab-', 'sec-');
      
        if (tabClass === currentSection) {
          if (parent) {
            parent.classList.add('active'); // Agrega 'active' al padre
          }
        } else {
          if (parent) {
            parent.classList.remove('active'); // Remueve 'active' del padre
          }
        }
      });


    });



    /* collapse */ 
    document.querySelectorAll('.dropdown-title').forEach((title) => {
      title.addEventListener('click', function () {
        const dropdown = this.parentElement;
    
        // Toggle active class on the dropdown
        dropdown.classList.toggle('active');
    
        // Close other dropdowns (optional, if needed)
        document.querySelectorAll('.dropdown').forEach((d) => {
          if (d !== dropdown) {
            d.classList.remove('active');
          }
        });
      });
    });

    // Responsive behavior
    const handleResize = () => {
        const isMobile = window.innerWidth < 768;
        document.querySelectorAll('.text-block-content').forEach(content => {
        //content.style.display = isMobile ? 'none' : 'block';
        });
    };

    window.addEventListener('resize', handleResize);
    handleResize(); // Initialize on load



  });
  